<template>
  <section>
    <div class="container">
      <div class="jumbo jumbo--md">
        <div class="row">
          <div class="col-m-4 mb-30">
            <img :src="require('@/assets/img/savagelp/thumb.jpg')" class="img-responsive mb-12" />
            <a :href="require('@/assets/img/savagelp/full.jpg')" class="l-link" target="_blank">
              <SvgIcon name="search" />
              <span>Просмотреть макет</span>
            </a>
          </div>
          <div class="col-m-8">
            <article class="article mb-24">
              <h3>Savage Landing Page</h3>
              <p>SavageAI - автоматизированный бот для продвижения в соц.сети Instagram</p>
              <p>Разработана посадочная страница для привлечения клиентов.</p>
            </article>
            <div class="row">
              <div class="col-m-5">
                <div class="feature mb-24">
                  <div class="feature__label">География проекта</div>
                  <div class="feature__content">Лос-Анджелес, США</div>
                </div>
              </div>
              <div class="col-m-5">
                <div class="feature mb-24">
                  <div class="feature__label">Срок реализации</div>
                  <div class="feature__content">2 недели</div>
                </div>
              </div>
            </div>
            <div class="feature mb-24">
              <div class="feature__label">Тех. стек</div>
              <div class="feature__content">JS/jQuery, SCSS, OctoberCMS, Git, Nginx</div>
            </div>
            <div>
              <a href="#" @click.prevent="showModal('5e60b459ad16fa004472f7c5')" class="button">Расчет Стоимости</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-60">
      <h3 class="section__title">Другие проекты</h3>
      <Portfolio />
    </div>
    <div class="text-center">
      <a href="#" @click.prevent="showModal('5e60b459ad16fa004472f7c5')" class="button">Расчет Стоимости</a>
    </div>
    <Clients />
    <VueFooter />
  </section>
</template>
<script>
const name = 'jobbooworkerLP'

import Portfolio from '@/components/Portfolio.vue'
import Clients from '@/components/Clients.vue'
import VueFooter from '@/components/VueFooter.vue';
import SvgIcon from '@/components/SvgIcon.vue';



export default {
  name,
  components: {
    Portfolio,
    Clients,
    VueFooter,
    SvgIcon
  }
}

</script>
